import Ajax from '../../../../common/js/Ajax.js';
import ButtonUtils from '../../../../common/js/ButtonUtils.js';
import Form from '../../../../common/js/form/Form.js';
import LangUtils from '../../../../common/js/LangUtils.js';
import Widget from '../../../../common/js/Widget.js';

import ERROR_TEMPLATE from './ContactFormWidget-error.hbs';
import SUCCESS_TEMPLATE from './ContactFormWidget-success.hbs';

export default class ContactFormWidget extends Widget {

	constructor($widget) {
		super($widget);
		this.$sendButton = $widget.find('[type="submit"]');

		Ajax.rpc('/contact/prepareForm', token => {
			this.token = token;
			ButtonUtils.setState(this.$sendButton, 'none');
		}, () => {
			this.showError();
		});

		Form.onSubmit($widget, action => {
			$widget.find('.js_result').empty();

			var form = {
				site: 'thomasjacob.de',
				name: action.findField('name').val(),
				email: action.findField('email').val(),
				subject: action.findField('subject').val(),
				content: action.findField('content').val()
			};

			form.formToken = form.email.length + this.token + form.subject.length;

			Ajax.rpc('/contact/saveForm', form, () => {
				action.ok();
				this.showSuccess(action);
			}, () => {
				action.error();
				this.showError(action);
			});
		});
	}

	showError() {
		this.$sendButton.hide();
		this.$widget.find('.js_result').html(ERROR_TEMPLATE({lang: LangUtils.getLang()}));
	}

	showSuccess() {
		this.$sendButton.hide();
		this.$widget.find('.js_result').html(SUCCESS_TEMPLATE({lang: LangUtils.getLang()}));
	}
}
